<template>
  <modal
    :showTopDismissButton="true"
    :showFooter="false"
    @dismiss="dismiss"
  >
    <div slot="body">
      <div class="modal-content pt10 pb10">
        <slot />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  methods: {
    dismiss() {
      this.$emit('dismiss')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  font-size: 1.0rem;
}
</style>
